import axiosOriginal, { AxiosResponse, isAxiosError } from "axios";

const config =
  window.location.pathname === "/kids"
    ? {
        headers: {
          "Ls2pac-config-type": "kids",
        },
      }
    : {
        headers: {
          "Ls2pac-config-type": "pac",
          "Ls2pac-config-name": window["config"],
        },
      };

export const axios = axiosOriginal.create(config);

export const isNetworkError = (error: unknown): boolean => {
  return isAxiosError(error) && !error.response;
};

export const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

// handles intermittent network errors by retrying the request
export const withRetry = async <T>(
  request: () => Promise<AxiosResponse<T>>,
  maxRetries: number = 3,
  delayMS: number = 750,
): Promise<AxiosResponse<T>> => {
  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      return await request();
    } catch (error: unknown) {
      const isLastAttempt = attempt === maxRetries - 1;
      if (!isNetworkError(error) || isLastAttempt) {
        throw error;
      }
      await sleep(delayMS);
    }
  }
};
